<template>
  <div class="tiles">
    <div class="tile"><span class="num">{{ stats.dialed }}</span><span class="lbl">Dialed</span></div>
    <div class="tile"><span class="num">{{ stats.connected }}</span><span class="lbl">Connected</span></div>
    <div class="tile"><span class="num">{{ stats.skipped }}</span><span class="lbl">Skipped</span></div>
    <div class="tile"><span class="num">{{ stats.noAnswer }}</span><span class="lbl">No answer</span></div>
    <div v-if="stats.failed > 0" class="tile"><span class="num">{{ stats.failed }}</span><span class="lbl">Failed</span></div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  stats: { dialed: number; connected: number; skipped: number; noAnswer: number; failed: number }
}>()
</script>

<style scoped>
.tiles { display: grid; grid-template-columns: repeat(auto-fit, minmax(84px, 1fr)); gap: var(--space-3); width: 100%; }
.tile { display: flex; flex-direction: column; align-items: center; gap: var(--space-1); padding: var(--space-4) var(--space-3); border-radius: var(--radius-lg); background: var(--color-bg-surface); border: 1px solid var(--color-border-subtle); box-shadow: var(--shadow-sm); }
.num { font-family: var(--font-display); font-size: var(--fs-xl); font-weight: var(--fw-semibold); color: var(--color-text-primary); font-variant-numeric: tabular-nums; line-height: 1; }
.lbl { font-size: var(--fs-xs); font-weight: var(--fw-semibold); letter-spacing: var(--tracking-wide); text-transform: uppercase; color: var(--color-text-tertiary); }
</style>
